<template>
  <!-- Explore Our Categories -->
  <section class="explore-categories common-padding">
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-3"></div>
          <div
            class="col-md-6 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Explore Our Categories</h2>
            <p>The most trendy accommodations available</p>
          </div>
          <div
            class="col-md-3 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          >
            <router-link to="categories" class="btn btn-view"
              >View all Catgeorries</router-link
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="car-class-carousel">
            <div
              class="best-places-rent-slider owl-carousel owl-theme"
              data-aos="fade-right"
            >
            <Carousel  :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
						<Slide v-for="item in IndexNineCategory" :key="item.id">
              <div class="best-room">
                <div class="best-room-img">
                  <router-link to="listing-list-sidebar"
                    ><img
                      :src="require(`@/assets/img/featured/${item.image}`)"
                      class="img-fluid"
                      alt=""
                  /></router-link>
                </div>
                <router-link to="listing-list-sidebar">
                  <div class="best-room-type">
                    <h5>{{ item.title }}</h5>
                    <span>{{ item.text }}</span>
                    <i class="fa-solid fa-arrow-right-long"></i>
                  </div>
                </router-link>
              </div>
              </Slide>
							<template #addons>
								<Pagination />
							</template>
					</Carousel>	             
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Explore Our Categories -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexNineCategory from '@/assets/json/indexNineCategory.json'
    export default {
        data(){
			return{
				IndexNineCategory: IndexNineCategory,
				Venue: ["Wedding Venue", "Reception", "Party Hall"],
				Location: ["Bangalore, India" , "Delhi", "Hyderabad"],
				Guest : ["10", "20", "30"],
				settings: {
				itemsToShow: 1,
				snapAlign: "center"
			},
		
			breakpoints: {
				575: {
					itemsToShow: 2,
					snapAlign: "center"
				},
				// 700px and up
				700: {
					itemsToShow: 3,
					snapAlign: "center"
				},
				// 1024 and up
				1000: {
					itemsToShow: 4,
					snapAlign: "start"
				}
			},
			};
		},
		components: {
			Carousel,
			Slide,
			Pagination,
			Navigation,
		},
		mouted() {},
    };
</script>